const setAnalyticsDataLayer = (action, product) => {
  let info = {};
  if (action === 'add_cart') {
    info = {
      event: 'addToCart',
      ecommerce: {
        currencyCode: 'RUB',
        add: {
          products: [product],
        },
      },
    };
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(info);
};

export default setAnalyticsDataLayer;
